/*
  PRP cart cross sell.

  Seeds Shopify's own recommendations from the first item in the cart, filters
  out anything already in there, and renders a size picker plus an add button
  per product. Injected into the drawer and re-injected after every cart render,
  same approach as the free shipping bar and for the same reason:
  snippets/cart-drawer.liquid is 36KB and cannot be partially edited.

  PLACEMENT MATTERS. The drawer is a fixed height flex column and
  cart-drawer-items is flex: 1 with overflow: auto. A fixed height sibling
  between it and .drawer__footer collapses the line items to zero height, so
  this block goes INSIDE cart-drawer-items and scrolls with the cart.

  Sizes are why the add button is not one tap. Adding a garment without
  choosing a size would either guess for the customer or fail silently.
*/
(function () {
  var LIMIT = 4;
  var isSyncing = false;
  var cache = {};

  function drawerInner() {
    return document.querySelector('cart-drawer .drawer__inner');
  }

  function scrollRegion() {
    return document.querySelector('cart-drawer cart-drawer-items');
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function recommendations(productId) {
    if (cache[productId]) return Promise.resolve(cache[productId]);

    var url =
      root() +
      'recommendations/products.json?product_id=' +
      productId +
      '&limit=10&intent=related';

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('recommendations failed');
        return response.json();
      })
      .then(function (data) {
        cache[productId] = data.products || [];
        return cache[productId];
      });
  }

  function buildItem(product) {
    var item = document.createElement('li');
    item.className = 'prp-upsell__item';

    var image = product.featured_image || (product.images && product.images[0]) || '';
    var available = (product.variants || []).filter(function (variant) {
      return variant.available;
    });
    if (!available.length) return null;

    var media =
      '<div class="prp-upsell__media">' +
      (image ? '<img src="' + image + '" alt="" loading="lazy" width="56" height="70">' : '') +
      '</div>';

    /* A single default variant needs no picker. Anything with real options gets
       a select, because guessing a size on the customer's behalf is worse than
       asking. */
    var picker = '';
    var onlyDefault =
      available.length === 1 && /default/i.test(available[0].title || '');

    if (!onlyDefault) {
      picker = '<select class="prp-upsell__size" data-prp-upsell-variant>';
      available.forEach(function (variant) {
        picker +=
          '<option value="' + variant.id + '">' + variant.title + '</option>';
      });
      picker += '</select>';
    } else {
      picker = '<input type="hidden" data-prp-upsell-variant value="' + available[0].id + '">';
    }

    item.innerHTML =
      media +
      '<div class="prp-upsell__info">' +
      '<p class="prp-upsell__name">' + product.title + '</p>' +
      picker +
      '<p class="prp-upsell__price">' + money(available[0].price) + '</p>' +
      '</div>' +
      '<button type="button" class="prp-upsell__add" data-prp-upsell-add>Add</button>';

    return item;
  }

  function add(button) {
    var item = button.closest('.prp-upsell__item');
    var field = item && item.querySelector('[data-prp-upsell-variant]');
    if (!field || !field.value) return;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(field.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        /* Hand the response to the theme's own renderer so the drawer, the
           totals and the cart bubble all update the way they normally would. */
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original;
      });
  }

  function render(products, cartProductIds) {
    var region = scrollRegion();
    if (!region || region.querySelector('[data-prp-upsell]')) return;

    var shortlist = products
      .filter(function (product) {
        return cartProductIds.indexOf(product.id) === -1;
      })
      .slice(0, LIMIT);

    if (!shortlist.length) return;

    var block = document.createElement('div');
    block.className = 'prp-upsell';
    block.setAttribute('data-prp-upsell', '');
    block.innerHTML =
      '<p class="prp-upsell__title">Others also bought</p>' +
      '<ul class="prp-upsell__list"></ul>';

    var list = block.querySelector('.prp-upsell__list');
    var rendered = 0;

    shortlist.forEach(function (product) {
      var node = buildItem(product);
      if (node) {
        list.appendChild(node);
        rendered += 1;
      }
    });

    if (!rendered) return;

    block.addEventListener('click', function (event) {
      var button = event.target.closest('[data-prp-upsell-add]');
      if (button) add(button);
    });

    region.appendChild(block);
  }

  function sync() {
    if (isSyncing) return;

    var region = scrollRegion();
    if (!region || region.querySelector('[data-prp-upsell]')) return;
    if (!drawerInner()) return;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;

        var seed = cart.items[0].product_id;
        var ids = cart.items.map(function (line) {
          return line.product_id;
        });

        return recommendations(seed).then(function (products) {
          isSyncing = true;
          render(products, ids);
        });
      })
      .catch(function () {
        /* Fail quiet. No cross sell is fine; a broken drawer is not. */
      })
      .then(function () {
        window.requestAnimationFrame(function () {
          isSyncing = false;
        });
      });
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    sync();

    var observer = new MutationObserver(function () {
      if (isSyncing) return;
      sync();
    });
    observer.observe(drawer, { childList: true, subtree: true });

    var openObserver = new MutationObserver(function () {
      if (drawer.classList.contains('active')) sync();
    });
    openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
